var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.444 11.034c.124.187.333.3.557.3h10a.67.67 0 0 0 .612-.405l2-4.666a.666.666 0 0 0-.612-.93h-.667V2.667c0-.736-.598-1.334-1.333-1.334H6.934L5.411.142A.67.67 0 0 0 5.001 0H1.667C.932 0 .334.598.334 1.333v9.334h.005a.67.67 0 0 0 .105.367M10.561 10H2.012l1.429-3.333h8.549zm.44-7.333v2.666H3a.67.67 0 0 0-.613.404l-.72 1.682V2.667z"
  })));
};
export default SvgFile;